var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"page-404"},[_c('i',{staticClass:"page-404-icon"}),_c('p',{staticClass:"page-404-text"},[_vm._v("出错啦 ？访问页面不存在")]),_c('div',{staticClass:"page-404-back"},[_c('a',{staticClass:"page-404-back-button",attrs:{"href":"javascript:;"},on:{"click":_vm.back}},[_vm._v("返回")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }